import { render, staticRenderFns } from "./related_party.vue?vue&type=template&id=0414e8ce&"
import script from "./related_party.vue?vue&type=script&lang=js&"
export * from "./related_party.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports